import React from "react";
import "./landing-step-data.css";

const LandingStepData = () => {
  return (
    <div className="section-data">
      <div className="group-381-2-xx">
        <div className="fishing-32 poppins-semi-bold-astronaut-15px">
          Landing
        </div>
        <img className="landing-icon" src="/img/group-74-2@2x.svg" />
      </div>
      <div className="group-37">
        <div className="course-2 poppins-semi-bold-tundora-13px">Course:</div>
        <div className="route-slooq-1 text">ROUTE SLOOQ</div>
      </div>
      <div className="group-37-7">
        <div className="date-21 poppins-semi-bold-tundora-13px">Date:</div>
        <div className="date-22 text">10/06/2022</div>
      </div>
      <div className="group-379">
        <div className="time-2 poppins-semi-bold-tundora-13px">Time:</div>
        <div className="text-8-1 text">09:43:00</div>
      </div>
    </div>
  );
};

export default LandingStepData;
